<template>
  <div>
    <div class="card mb-3">
      <div class="card-header">過去の予約</div>

      <div class="card-body">

        <div class="border p-2 mb-3">
          <div class="mb-2">
            ペナルティ無しのキャンセルを除く過去3ヶ月分の予約一覧が表示されます。
          </div>

          <ol class="mb-2">
            <li>
              <span class="label-cancel">キャンセル(会員)</span> <span class="label-cancel">キャンセル(店舗)</span><br>
              ペナルティ有りのキャンセル<br></li>
            <li>
              <span class="label-cancel">自動キャンセル(ペナルティ)</span><br>
              1.により自動キャンセルとなったご予約
            </li>
            <li>
              <span class="label-noshow">キャンセル(店舗)</span><br>
              無断キャンセル
            </li>
            <li>
              <span class="label-noshow">自動キャンセル(ペナルティ)</span><br>
              3. により自動キャンセルとなったご予約
            </li>
          </ol>
        </div>

        <ul v-if="pastReservations.length">
          <li v-for="reservation in pastReservations">
            {{ moment(reservation.start_datetime).format("M月D日 HH:mm") }}-{{ moment(reservation.end_datetime).format("HH:mm") }}
            ({{ moment(reservation.end_datetime).diff(reservation.start_datetime, 'minutes') }}分)
            <span class="badge badge-success">{{ reservation.program.room.name }}</span>
            <template v-if="reservation.program.room_id === 1">
              {{ reservation.program.name }}
            </template>
            <template v-else-if="reservation.program.room_id === 2">
              <template v-if="reservation['program_daily_schedule']">
                {{ reservation["program_daily_schedule"].name }}
              </template>
            </template>

            <!-- 状態 -->
            <template v-if="reservation.status === 'deleted_by_admin_without_penalty'">
              <span class="label-cancel">!<!-- 表示されないはずの要素 --></span>
            </template>
            <template v-else-if="reservation.status === 'deleted_by_admin_with_penalty'">
              <span class="label-cancel">キャンセル(店舗)</span>
            </template>
            <template v-else-if="reservation.status === 'deleted_by_admin_by_cancel_penalty'">
              <span class="label-cancel">自動キャンセル(ペナルティ)</span>
            </template>

            <template v-if="reservation.status === 'deleted_by_member_without_penalty'">
              <span class="label-cancel">!<!-- 表示されないはずの要素 --></span>
            </template>
            <template v-else-if="reservation.status === 'deleted_by_member_with_penalty'">
              <span class="label-cancel">キャンセル(会員)</span>
            </template>
            <template v-else-if="reservation.status === 'deleted_by_member_by_cancel_penalty'">
              <span class="label-cancel">自動キャンセル(ペナルティ)</span>
            </template>

            <template v-else-if="reservation.status === 'noshow'">
              <span class="label-noshow">キャンセル(店舗)</span>
            </template>
            <template v-else-if="reservation.status === 'deleted_by_admin_by_noshow_penalty'">
              <span class="label-noshow">自動キャンセル(ペナルティ)</span>
            </template>
          </li>
        </ul>
        <ul v-else>
          <li v-if="!this.$store.state.loading.isLoading">過去の予約はありません</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pastReservations: [],
    }
  },
  created: function () {
    this.$store.commit("loading/setLoading", true);

    // 過去の予約情報を取得
    this.getPastReservations();

    this.$store.commit("loading/setLoading", false);
  },
  methods: {
    // 過去の予約情報を取得
    async getPastReservations() {
      await axios.get('/member/api/reservations/past')
          .then(response => {
            this.pastReservations = response.data.reservations;
          })
          .catch(error => this.$store.state.error.code = error.response.status)
    },
  },
}
</script>
